import { render, staticRenderFns } from "./articoliDettaglio.html?vue&type=template&id=82d238d0&scoped=true&"
import script from "./ArticoliDettaglio.vue?vue&type=script&lang=js&"
export * from "./ArticoliDettaglio.vue?vue&type=script&lang=js&"
import style0 from "./ArticoliDettaglio.vue?vue&type=style&index=0&id=82d238d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d238d0",
  null
  
)

export default component.exports